import { faPlus } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Button, DashboardModule, Link } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useCampaign'
import useCampaignInspection from '@hooks/useCampaignInspection'
import useCampaignInspections from '@hooks/useCampaignInspections'

import CampaignInspectionListItem from '@components/CampaignInspections/CampaignInspectionListItem'

import type { CampaignModel } from '@models/types'

interface CampaignInspectionProps {
  campaign: CampaignModel,
  readOnly?: boolean,
}

const CampaignInspections = (props: CampaignInspectionProps) => {
  const { campaign, readOnly } = props

  const campaignInspectionsPayload = useCampaignInspections({
    filters: { campaign_id: campaign.id },
    performHttpRequests: !!campaign.id,
  })

  const {
    filteredCampaignInspections,
    hasFilteredCampaignInspections,
    loading,
  } = campaignInspectionsPayload

  const {
    callbacks: {
      createOrEditCampaignInspection,
    },
  } = useCampaignInspection({ campaign_id: campaign.id })

  const { campaignEditDetailsUrl } = generateUrls({ id: campaign.id })

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={
        readOnly && (
          <Link href={campaignEditDetailsUrl} textProps={{ fontSize: 'small' }}>
            Manage
          </Link>
        )
      }
      loading={loading}
      title="Open for Inspections"
    >
      {!loading && hasFilteredCampaignInspections && (
        <DashboardModule.ScrollableSection>
          {filteredCampaignInspections.map(campaignInspection => (
            <CampaignInspectionListItem
              campaignInspection={campaignInspection}
              key={campaignInspection.id}
              readOnly={readOnly}
            />
          ))}
        </DashboardModule.ScrollableSection>
      )}

      {!loading && !hasFilteredCampaignInspections && readOnly && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No inspections in this campaign
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            You can add inspections in the Details page or in your CRM if the campaign is synced.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      {!readOnly && (
        <DashboardModule.Footer boxProps={{ borderTop: !hasFilteredCampaignInspections ? 'none' : '1px solid' }}>
          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => createOrEditCampaignInspection()}
              // @ts-expect-error TS2322
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Inspection
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      )}
    </DashboardModule>
  )
}

export default CampaignInspections
